var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05645 0 0 8.05645 0 18C0 27.9435 8.05645 36 18 36C27.9435 36 36 27.9435 36 18C36 8.05645 27.9435 0 18 0ZM18 33.6774C9.3629 33.6774 2.32258 26.7097 2.32258 18C2.32258 9.43548 9.29032 2.32258 18 2.32258C26.5645 2.32258 33.6774 9.3629 33.6774 18C33.6774 26.6371 26.6371 33.6774 18 33.6774ZM24.8226 12.9919C25.1855 12.629 25.1855 12.121 24.8226 11.7581L24.2419 11.1774C23.879 10.8145 23.371 10.8145 23.0081 11.1774L18 16.1855L12.9194 11.1774C12.629 10.8145 12.0484 10.8145 11.6855 11.1774L11.1048 11.7581C10.7419 12.121 10.7419 12.629 11.1048 12.9919L16.1129 18L11.1048 23.0806C10.7419 23.371 10.7419 23.9516 11.1048 24.3145L11.6855 24.8952C12.0484 25.2581 12.629 25.2581 12.9194 24.8952L18 19.8871L23.0081 24.8952C23.371 25.2581 23.879 25.2581 24.2419 24.8952L24.8226 24.3145C25.1855 23.9516 25.1855 23.371 24.8226 23.0806L19.8145 18L24.8226 12.9919Z",
    fill: "#4D4F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupCloseIcon);
export default __webpack_public_path__ + "static/media/PopupCloseIcon.8fa95faa54760d6c9fbbd2d5959a01a2.svg";
export { ForwardRef as ReactComponent };